import React, { useState } from 'react';
import { Trophy, Heart, Star } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'gold' | 'base'>('gold');
  return <section id="pricing" className="bg-[#0B1A2E] py-24 px-4 font-sans" data-id="element-57">
      <div className="max-w-lg mx-auto" data-id="element-58">
        {/* Header */}
        <div className="text-center mb-10" data-id="element-59">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-4 tracking-tight drop-shadow-md" data-id="element-60">
            ELEGÍ TU OPCIÓN
          </h2>
          <p className="text-lg text-gray-400" data-id="element-61">
            Seleccioná el pack que mejor se adapte a tu objetivo.
          </p>
        </div>

        {/* Cards Container */}
        <div className="space-y-6" data-id="element-62">
          {/* GOLD CARD */}
          <div onClick={() => setSelected('gold')} className={`cursor-pointer rounded-2xl p-6 md:p-8 transition-all duration-300 border-2 ${selected === 'gold' ? 'border-[#22c55e] bg-[#0F2341] shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-white/10 bg-[#0B1A2E] hover:border-white/20'}`} data-id="element-63">
            {/* Title Row */}
            <div className="flex items-center mb-4" data-id="element-64">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center mr-4 flex-shrink-0 transition-colors ${selected === 'gold' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-500'}`} data-id="element-65">
                {selected === 'gold' && <div className="w-2.5 h-2.5 bg-white rounded-full" data-id="element-66" />}
              </div>
              <Trophy className={`w-6 h-6 mr-3 ${selected === 'gold' ? 'text-[#F0C14B]' : 'text-gray-400'}`} data-id="element-67" />
              <h3 className="text-2xl font-black text-white tracking-wide" data-id="element-68">
                BUNDLE GOLD
              </h3>
            </div>

            {/* Price Row */}
            <div className="pl-10 mb-4 flex items-baseline gap-3" data-id="element-69">
              <span className="text-gray-500 line-through text-lg font-medium" data-id="element-70">
                $70.000
              </span>
              <span className="text-4xl font-black text-[#22c55e]" data-id="element-71">
                $29.990
              </span>
            </div>

            {/* Badges */}
            <div className="pl-10 flex flex-wrap gap-3 mb-6" data-id="element-72">
              <span className="inline-flex items-center bg-[#22c55e] text-white text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-73">
                <Star className="w-3.5 h-3.5 mr-1.5 fill-current" data-id="element-74" /> MÁS ELEGIDO
              </span>
              <span className="inline-flex items-center border border-[#22c55e] text-[#22c55e] text-xs font-bold px-3 py-1.5 rounded-full uppercase tracking-wider" data-id="element-75">
                AHORRÁS $40.010
              </span>
            </div>

            {/* Features */}
            <div className="pl-10 space-y-2 text-gray-300 text-sm md:text-base" data-id="element-76">
              <p data-id="element-77">5 Tomos + 4 Bonos</p>
              <p className="font-bold text-white mt-3" data-id="element-78">
                + Tomo Gold (La Bóveda)
              </p>
              <p className="text-gray-400 pl-2" data-id="element-79">
                - Matrices de Planificación Anual
              </p>
              <p className="text-gray-400 pl-2" data-id="element-80">
                - Diccionario de Informes de Boletín
              </p>
              <p className="mt-3" data-id="element-81">354 páginas de recursos listos</p>
              <p data-id="element-82">Garantía de 7 días</p>
            </div>
          </div>

          {/* BASE CARD */}
          <div onClick={() => setSelected('base')} className={`cursor-pointer rounded-2xl p-6 md:p-8 transition-all duration-300 border-2 ${selected === 'base' ? 'border-[#22c55e] bg-[#0F2341] shadow-[0_0_30px_rgba(34,197,94,0.15)]' : 'border-white/10 bg-[#0B1A2E] hover:border-white/20'}`} data-id="element-83">
            {/* Title Row */}
            <div className="flex items-center mb-4" data-id="element-84">
              <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center mr-4 flex-shrink-0 transition-colors ${selected === 'base' ? 'border-[#22c55e] bg-[#22c55e]' : 'border-gray-500'}`} data-id="element-85">
                {selected === 'base' && <div className="w-2.5 h-2.5 bg-white rounded-full" data-id="element-86" />}
              </div>
              <Heart className={`w-6 h-6 mr-3 ${selected === 'base' ? 'text-[#22c55e] fill-current' : 'text-gray-400'}`} data-id="element-87" />
              <h3 className="text-2xl font-black text-white tracking-wide" data-id="element-88">
                PACK BASE
              </h3>
            </div>

            {/* Features */}
            <div className="pl-10 space-y-2 text-gray-400 text-sm md:text-base mb-4" data-id="element-89">
              <p data-id="element-90">5 Tomos + 4 Bonos</p>
              <p data-id="element-91">215 páginas de recursos</p>
            </div>

            {/* Price Row */}
            <div className="pl-10 flex items-baseline gap-3" data-id="element-92">
              <span className="text-gray-600 line-through text-lg font-medium" data-id="element-93">
                $55.000
              </span>
              <span className="text-3xl font-black text-[#22c55e]" data-id="element-94">
                $19.990
              </span>
            </div>
          </div>
        </div>

        {/* CTA Button */}
        <a href={selected === 'gold' ? 'https://fegion.shop/cart/46273580302475:1' : 'https://fegion.shop/cart/46273573060747:1'} target="_blank" rel="noopener noreferrer" className="w-full bg-[#22c55e] hover:bg-[#16a34a] text-white font-extrabold text-xl md:text-2xl py-5 rounded-xl mt-8 flex items-center justify-center transition-all duration-300 shadow-[0_0_20px_rgba(34,197,94,0.4)] hover:shadow-[0_0_30px_rgba(34,197,94,0.6)] transform hover:-translate-y-1 no-underline" data-id="element-95">
          <Heart className="w-6 h-6 mr-3 fill-current" data-id="element-96" />
          EMPEZAR HOY — {selected === 'gold' ? '$29.990' : '$19.990'}
        </a>

        {/* Footer Notes */}
        <div className="mt-12 text-center" data-id="element-97">
          <p className="text-gray-400 text-sm mb-6 max-w-md mx-auto leading-relaxed" data-id="element-98">
            ⚠️ <strong className="text-white" data-id="element-99">Nota:</strong> El Tomo Gold no
            estará disponible a este precio una vez que termine el período de
            lanzamiento. Si después de comprar el sistema base querés sumarlo,
            el precio será mayor.
          </p>
          <p className="text-xl md:text-2xl font-bold text-[#F0C14B]" data-id="element-100">
            El lunes que viene podés entrar al patio diferente.
          </p>
        </div>
      </div>
    </section>;
}